export default {
  state: {
    open: true
  },
  mutations: {
    toggleOpen(state) {
      state.open = !state.open
    }
  },
  actions: {},
  getters: {
    isOpen: state => {
      return state.open
    }
  }
}
